export default __webpack_public_path__ + "static/media/FDS_logo_transparent.46faffd3.png";